import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import http from 'src/services/httpService';
import history from 'src/history';
import errorHandler from 'src/utils/error-handler';
import LoadingContainer from 'src/componentes/loading-container';

/**
 * Lista as versões geradas de uma apresentação (ou de uma reunião). Cada versão é uma "foto" da
 * apresentação no momento em que foi gerada; abrir uma mostra as telas daquele momento.
 */
const VersoesApresentacao = ({ apresentacaoId, reuniaoId }) => {
  const intl = useIntl();
  const [versoes, setVersoes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!apresentacaoId && !reuniaoId) return;

    setIsLoading(true);
    http
      .post('/Apresentacao/ObterVersoesApresentacao', {
        apresentacaoId: reuniaoId ? null : apresentacaoId,
        reuniaoId,
      })
      .then((response) => {
        setVersoes(response.data || []);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        errorHandler(error);
      });
  }, [apresentacaoId, reuniaoId]);

  const handleAbrirClick = (versao) => {
    history.push({
      pathname: '/acompanhar/apresentacao',
      search: `?versaoId=${versao.id}`,
    });
  };

  return (
    <LoadingContainer isLoading={isLoading}>
      {versoes.length === 0 ? (
        <span className="text-muted">
          <FormattedMessage id="label.nenhumaVersaoApresentacao" />
        </span>
      ) : (
        <table className="table table-sm mb-0">
          <thead>
            <tr>
              <th>
                <FormattedMessage id="label.dataVersao" />
              </th>
              <th>
                <FormattedMessage id="apresentacao" />
              </th>
              <th>
                <FormattedMessage id="label.geradaPor" />
              </th>
              <th>
                <FormattedMessage id="label.dadosVersao" />
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {versoes.map((versao) => (
              <tr key={versao.id}>
                <td>{new Date(versao.data).toLocaleString()}</td>
                <td>{versao.nome}</td>
                <td>{versao.usuarioNome}</td>
                <td>
                  <FormattedMessage
                    id={
                      versao.capturouDados
                        ? 'label.versaoComDados'
                        : 'label.versaoSomenteTelas'
                    }
                  />
                </td>
                <td className="text-right">
                  <a
                    tabIndex="-1"
                    style={{ cursor: 'pointer' }}
                    title={intl.formatMessage({ id: 'label.abrirVersao' })}
                    onClick={() => handleAbrirClick(versao)}
                  >
                    <FormattedMessage id="label.abrirVersao" />
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </LoadingContainer>
  );
};

export default VersoesApresentacao;
